<div class="authentication-fail-container">
  <div class="authentication-fail-card">
    <div class="icon-container">
      <img src="assets/images/icons/icon-authentication-failed.svg" alt="Authentication failed" class="auth-failed-icon">
    </div>

    <h1 class="title">{{ "auth_failed_title" | translate }}</h1>

    <div class="message-container">
      <p class="blocked-message"> <strong>{{ errorMessage }}</strong></p>

      <p class="contact-message">
        {{ "auth_failed_contact_message" | translate }}
        {{ "auth_failed_contact_team" | translate }}
        <a href="mailto:epayments@voxelgroup.net" class="email-link">{{ "auth_failed_contact_email" | translate }}</a>
      </p>
    </div>

    <button class="back-to-login-btn mb-5" (click)="goBackToLogin()">
      {{ "auth_failed_back_to_login" | translate }}
    </button>
  </div>
</div>
